export const UPGRADE_MODAL_SHOWN = 22783665;
export const PURCHASE = 22783673;

export const trackLinkedInConversion = (conversionId: number) => {
  try {
    if (typeof window.lintrk === 'function') {
      window.lintrk('track', { conversion_id: conversionId });
    }
  } catch (error) {
    console.warn('Error pushing to lintrk', error);
  }
};
